module.exports = __webpack_public_path__ + "static/media/icon_110.63f96c35.svg";